/**
 * This file is auto-generated from UnitTokenTranslation.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */
export const kg = lang => {
    switch (lang) {
        case 'en':
            return 'kg';
        case 'pl':
            return 'kg';
    }
};
export const lb = lang => {
    switch (lang) {
        case 'en':
            return 'lb';
        case 'pl':
            return 'lb';
    }
};
export const cm = lang => {
    switch (lang) {
        case 'en':
            return 'cm';
        case 'pl':
            return 'cm';
    }
};
const in$ = lang => {
    switch (lang) {
        case 'en':
            return 'in';
        case 'pl':
            return 'cale';
    }
};
export const mmHg = lang => {
    switch (lang) {
        case 'en':
            return 'mmHg';
        case 'pl':
            return 'mmHg';
    }
};
export { in$ as in };
//# sourceMappingURL=UnitTokenTranslation.loc.js.map